import type { ContactType } from "@prisma/client";

export const contactTypeOptions: {
    key: ContactType;
    label: string;
}[] = [
    {
        key: 'whatsappNumber',
        label: 'WhatsApp',
    },
    {
        key: 'email',
        label: 'Email',
    },
    {
        key: 'instagramUsername',
        label: 'Instagram',
    },
    {
        key: 'website',
        label: 'Website',
    },
    {
        key: 'tiktokUsername',
        label: 'TikTok',
    },
    {
        key: 'youTubeUrl',
        label: 'YouTube',
    },
    {
        key: 'facebookUrl',
        label: 'Facebook',
    },
    {
        key: 'telegramUsername',
        label: 'Telegram',
    },
    {
        key: 'linkedinUsername',
        label: 'LinkedIn',
    },
    {
        key: 'threadsUsername',
        label: 'Threads',
    },
    {
        key: 'twitterUsername',
        label: 'Twitter / X',
    },
    {
        key: 'gmapsUrl',
        label: 'Google Maps',
    },
    {
        key: 'lineUsername',
        label: 'LINE',
    },
    {
        key: 'spotifyUrl',
        label: 'Spotify',
    },
    {
        key: 'githubUsername',
        label: 'GitHub',
    },
    {
        key: 'pinterestUsername',
        label: 'Pinterest',
    },
    {
        key: 'mediumUrl',
        label: 'Medium',
    },
    {
        key: 'dribbbleUrl',
        label: 'Dribbble',
    },
    {
        key: 'behanceUrl',
        label: 'Behance',
    },
]

export function getContactTypeLabel(type: ContactType) {
    return contactTypeOptions.find(option => option.key === type)?.label || ''
}   